export const LIMITES_PRESTAMO = {
  ESTANDAR: {
    tasaInteres: {
      min: 10,
      max: 40
    },
    numeroCuotas: {
      min: 2,
      max: 8
    },
    label: 'Estándar'
  },
  EXTENDIDO: {
    tasaInteres: {
      min: 10,
      max: 50
    },
    numeroCuotas: {
      min: 2,
      max: 12
    },
    label: 'Extendido'
  }
};

export const TIPO_LIMITE = {
  ESTANDAR: 'ESTANDAR',
  EXTENDIDO: 'EXTENDIDO'
};
